import React from 'react';
import { ErrorType } from '~/types/handled-error';
import { ErrorRetryable } from '~/components/errors/error-retryable';
import { ErrorRequireRestart } from '~/components/errors/error-require-restart';

type Props = {
  errorType: ErrorType;
};
export const ErrorFromSSR: React.FC<Props> = ({ errorType }) => {
  switch (errorType) {
    case 'retryable':
      return <ErrorRetryable />;
    case 'require-restart':
      return <ErrorRequireRestart />;
  }
};
